import { useDispatch } from "react-redux"
import { useAppState } from "./useReduxState"
import { useMemo, useEffect } from "react"
import { getPageToFetch, getItemList } from "../Models/Client/RemoteData"
import { getCustomerList } from "../Actions/API/Backoffice/BackofficeActions"
import { Result } from "../Models/Utility/Result"
import { FetchState } from "../Models/Client/FetchState"
import {
    BackofficeCustomerParams,
    Customer
} from "../Models/API/BackofficeModel"

export const useCustomers = (
    params: BackofficeCustomerParams
): FetchState<{
    customers: Customer[]
    total: number
    canLoadMore: boolean
}> => {
    const dispatch = useDispatch()
    const customers = useAppState(state => state.api.backoffice.customers)

    useEffect(() => {
        const page = getPageToFetch(customers, params)

        if (page >= 0) {
            dispatch(getCustomerList(params, page))
        }
    }, [dispatch, params, customers])

    return useMemo(() => {
        if (
            customers === undefined ||
            customers.list === undefined ||
            JSON.stringify(params) !== JSON.stringify(customers.list?.params)
        ) {
            return undefined
        }

        return Result.ok({
            customers: getItemList(customers),
            total: customers.list.total,
            canLoadMore: customers.list.pages.length * 20 < customers.list.total
        })
    }, [customers, params])
}
